<template>
    <header class="bg-light p-3 border-bottom">
        <h5 class="m-0">Dashboard</h5>
    </header>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({});
</script>